/* eslint-disable no-nested-ternary */
import React, { useContext } from 'react'; //eslint-disable-line
import { observer } from 'mobx-react-lite';
import locationStoreContext from '../stores/locationStore';
import BoltIcon from './BoltIcon';
import Logo from './Logo';
import BusLogo from './BusLogo';

const StationHeader = observer(props => {
  const locationStore = useContext(locationStoreContext);
  const stationName = props.stationName ? props.stationName : locationStore.station ? locationStore.station.name : null;
  const isBus = props.isBus;
  return (
    <div className="station-header">
      {locationStore.station && (
        <span className="station-title">
          <span className="station-icons">
            {isBus && <BusLogo />}
            {props.isTrain && <Logo />}
          </span>
          <h1>{stationName}</h1>
          {props.isExpress && (<BoltIcon />)}
        </span>
      )}
    </div>
  );
});

export default StationHeader;
